export const SearchTypeDate = 4 as const;
export type TSearchTypeDate = typeof SearchTypeDate;

/** elementSubType1 */
export enum DateType {
	CREATION_DATE = 0,
	LAST_MODIFIED = 1,
	USER_DEFINED_ATTRIBUTE = 2,
	IMPORT_DATE = 3,
	EXPIRATION_DATE = 4,
}

/** elementSubType2 */
export enum DateSubType {
	LAST_THREE_MONTHS = 1,
	LAST_SIX_MONTHS = 2,
	LAST_YEAR = 3,
	BEFORE = 4,
	AFTER = 5,
	IN_BETWEEN = 6,
	LAST_WEEK = 7,
	LAST_MONTH = 8,
	TODAY = 9,
	YESTERDAY = 10,
}

/**
 * DateSubTypes that do not require a value
 */
export const DateNoValueTypes = [
	DateSubType.LAST_MONTH,
	DateSubType.LAST_SIX_MONTHS,
	DateSubType.LAST_THREE_MONTHS,
	DateSubType.LAST_WEEK,
	DateSubType.LAST_YEAR,
	DateSubType.TODAY,
	DateSubType.YESTERDAY,
] as const;

/**
 * DateSubTypes that require a single value
 */
export const DateSingleValueTypes = [
	DateSubType.AFTER,
	DateSubType.BEFORE,
] as const;

/**
 * DateTypes related to system attributes
 */
export const DateSystemDefinedTypes = [
	DateType.IMPORT_DATE,
	DateType.CREATION_DATE,
	DateType.LAST_MODIFIED,
	DateType.EXPIRATION_DATE,
] as const;

export type DoesNotRequireDate = typeof DateNoValueTypes[number];
export type RequiresSingleDate = typeof DateSingleValueTypes[number];
export type SystemDefined = typeof DateSystemDefinedTypes[number];
